import { useDeferredValue, useMemo } from 'react'
import type { IssueData } from '@app/types'
import type { Feed } from 'a11ywatch-web-wasm-pro'
import { observer } from 'mobx-react-lite'
import { FilterManager } from '@app/managers/filters'
import { getListHeight } from './utils'
import { FixedSizeList as List } from 'react-window'
import { IssueFeedGroupedCell } from '../general/cells/issue-feed-cell-grouped'

export type FeedItemProps = {
  feed: Feed
  data?: Map<string, Map<string, IssueData>>
  domain: string
  onScanEvent?: any
  index?: number
  highlightErrors?: boolean
}

interface RowProps {
  index: number
  style?: React.CSSProperties
}

//  pages grouped todo improve the speed
const PageListGroupedWrapper = () => {
  const sortedList = useDeferredValue(FilterManager.groupList)
  const issueCount = sortedList.length

  // TODO: RESIZE OVSERVER LIGHT HEIGHT
  const { size, height } = useMemo(
    () =>
      getListHeight({
        fullScreen: false,
        issueCount,
        paging: false,
        partial: true,
      }),
    [issueCount]
  )

  const Row = ({ index, style }: RowProps) => {
    const key = sortedList[index]
    const { issue, count, pages } = FilterManager.groups.get(key) ?? {
      issue: undefined,
      count: 0,
    }

    if (!issue) {
      return null
    }

    return (
      <IssueFeedGroupedCell
        item={issue}
        count={count}
        style={style}
        pages={pages}
      />
    )
  }

  return (
    <li className={`w-full h-full`}>
      <List
        height={height}
        itemCount={issueCount}
        itemSize={size}
        width={'100%'}
      >
        {Row}
      </List>
    </li>
  )
}

export const PageListGrouped = observer(PageListGroupedWrapper)
